// Subscription status enum - enforces state machine
export enum SubscriptionStatus {
  TRIAL = 'TRIAL',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FREE_TIER = 'FREE_TIER', // Payment failed after period end
}

// Payment method types
export enum PaymentMethod {
  UPI_AUTOPAY = 'UPI_AUTOPAY',
  CARD_SI = 'CARD_SI',
}

// Billing cycle options
export enum BillingCycle {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}

// Payment mandate types
export enum MandateType {
  UPI_AUTOPAY = 'UPI_AUTOPAY',
  CARD_SI = 'CARD_SI',
}

// Payment mandate status
export enum MandateStatus {
  PENDING = 'PENDING', // Awaiting customer approval
  ACTIVE = 'ACTIVE', // Approved and active
  PAUSED = 'PAUSED', // Temporarily paused
  REVOKED = 'REVOKED', // Cancelled by customer or system
  EXPIRED = 'EXPIRED', // Past validity date
}

// Subscription payment status
export enum PaymentStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  RETRY_SCHEDULED = 'RETRY_SCHEDULED',
  RETRY_PENDING = 'RETRY_PENDING',
  PENDING_CUSTOMER_AUTH = 'PENDING_CUSTOMER_AUTH',
}
